export const SETTINGS = "SETTINGS";
export const SETTINGS_LOADING = "SETTINGS_LOADING";
export const TRANSLATE = "TRANSLATE";
export const TRANSLATE_LOADING = "TRANSLATE_LOADING";
